var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import { useStore } from 'vuex-simple';
var SteppedPageMixin = /** @class */ (function (_super) {
    __extends(SteppedPageMixin, _super);
    function SteppedPageMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = useStore(_this.$store);
        return _this;
    }
    Object.defineProperty(SteppedPageMixin.prototype, "item", {
        /**
         * Current item
         */
        get: function () {
            return this.store.steppedPage.item;
        },
        /**
         * Set the item
         */
        set: function (data) {
            this.store.steppedPage.setItem(data);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SteppedPageMixin.prototype, "step", {
        /**
         * Get the step
         */
        get: function () {
            return this.store.steppedPage.step;
        },
        /**
         * Set the step
         */
        set: function (data) {
            this.store.managementPage.closeFilterSidesheet();
            this.store.managementPage.closeCrudSidesheet();
            this.store.steppedPage.setStep(data);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SteppedPageMixin.prototype, "readonly", {
        /**
         * If the logged in user has read only permissions
         */
        get: function () {
            return (this.store.managementPage.crudSidesheetMode === 'read' ||
                this.store.managementPage.readonly);
        },
        /**
         * Set the read only permission
         */
        set: function (val) {
            this.store.managementPage.setReadonly(val);
        },
        enumerable: false,
        configurable: true
    });
    SteppedPageMixin = __decorate([
        Component
    ], SteppedPageMixin);
    return SteppedPageMixin;
}(Vue));
export default SteppedPageMixin;
